import { Button, Icon } from "@nexus/ui"
import type { RowJobStatus } from "@nexus/contracts"
import { useTranslation } from "react-i18next"

export interface RowJobStatusBadgeProps {
  status: RowJobStatus
  onRetry?: () => void
}

const statusConfig: Record<RowJobStatus, { icon: "clock" | "loader" | "check-circle" | "x-circle"; labelKey: string; colorClass: string; iconExtra?: string }> = {
  pending: { icon: "clock", labelKey: "opportunities.jobStatus.pending", colorClass: "text-muted-foreground" },
  processing: { icon: "loader", labelKey: "opportunities.jobStatus.processing", colorClass: "text-status-info", iconExtra: "animate-spin" },
  done: { icon: "check-circle", labelKey: "opportunities.jobStatus.done", colorClass: "text-status-success" },
  failed: { icon: "x-circle", labelKey: "opportunities.jobStatus.failed", colorClass: "text-destructive" },
}

export function RowJobStatusBadge({ status, onRetry }: RowJobStatusBadgeProps) {
  const { t } = useTranslation()
  const cfg = statusConfig[status]

  return (
    <div className="flex items-center gap-1.5">
      <Icon name={cfg.icon} size="sm" className={`${cfg.colorClass} ${cfg.iconExtra ?? ""}`} />
      <span className={`text-xs font-medium ${cfg.colorClass}`}>{t(cfg.labelKey)}</span>
      {status === "failed" && onRetry && (
        <Button
          variant="ghost"
          size="xs"
          onClick={(e) => {
            e.stopPropagation()
            onRetry()
          }}
        >
          {t("common.retry")}
        </Button>
      )}
    </div>
  )
}
